import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLanguage } from "@/utils/util";
import zhCN from "./zh-CN.json";
import zhHK from "./zh-HK.json";
import enUS from "./en-US.json";

Vue.use(VueI18n);

// 注意：属性名 是不同语言的标识，用于后续切换时传递使用。
const messages = {
  "zh-CN": zhCN as any,
  "zh-HK": zhHK as any,
  "en-US": enUS as any,
};

const i18n = new VueI18n({
  // 设置默认语言为中文
  locale: getLanguage(),
  messages: messages,
  fallbackLocale: "zh-CN",
});

export const t = i18n.t.bind(i18n);

export default i18n;
